/*! facett renewal — gift-scenes
 *  - SP 画像: PC 3枚をフェード（ヒーロー同型・ドットなし）
 *  - 商品: recommended 同型横スライダー
 */
(function () {
  var CSS_HREF = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.css';
  var JS_SRC = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.js';
  var MQ_SP = '(max-width: 767px)';

  function loadStylesheet(href) {
    if (document.querySelector('link[href="' + href + '"]')) return Promise.resolve();
    return new Promise(function (resolve, reject) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.onload = function () {
        resolve();
      };
      link.onerror = reject;
      document.head.appendChild(link);
    });
  }

  function loadScript(src) {
    if (window.Swiper) return Promise.resolve();
    var existing = document.querySelector('script[data-facett-swiper]');
    if (existing) {
      return new Promise(function (resolve) {
        existing.addEventListener('load', function () {
          resolve();
        });
        if (window.Swiper) resolve();
      });
    }
    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.setAttribute('data-facett-swiper', '1');
      script.onload = function () {
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function isSp() {
    return window.matchMedia(MQ_SP).matches;
  }

  function readCssPx(root, prop, fallback) {
    var probe = document.createElement('div');
    probe.style.cssText =
      'position:absolute;visibility:hidden;pointer-events:none;height:0;width:var(' + prop + ')';
    root.appendChild(probe);
    var px = probe.offsetWidth;
    root.removeChild(probe);
    return px || fallback;
  }

  function getCardW(root) {
    return readCssPx(root, '--facett-gs-card', 206);
  }

  function getGap(root) {
    return readCssPx(root, '--facett-gs-gap', 16);
  }

  function getInsetPx(root) {
    return readCssPx(root, '--facett-gs-inset', 0);
  }

  function getContentMax(root) {
    return readCssPx(root, '--facett-gs-content', 1440);
  }

  function getSpInset(root) {
    return readCssPx(root, '--facett-gs-sp-inset', 24) || 24;
  }

  function getContentOffset(root, el) {
    if (!el) return 24;

    var ref = document.querySelector(
      '.facett-gift-intro__list, .facett-material__grid, .facett-category__grid'
    );
    if (ref) {
      var delta = Math.round(ref.getBoundingClientRect().left - el.getBoundingClientRect().left);
      if (delta > 0) return delta;
    }

    var vw = window.innerWidth || document.documentElement.clientWidth;
    if (vw < 576) {
      return getSpInset(root);
    }

    var inset = getInsetPx(root);
    var content = getContentMax(root);
    return Math.max(inset, Math.round((vw - content) / 2));
  }

  function needsSwipe(el, slideCount, offsetBefore, offsetAfter, cardW, gap) {
    if (!el || slideCount <= 1) return false;
    var w = cardW || 206;
    var g = gap || 8;
    var total =
      slideCount * w + Math.max(0, slideCount - 1) * g + (offsetBefore || 0) + (offsetAfter || 0);
    return total > el.clientWidth + 1;
  }

  /* ---- SP 画像フェード（Swiperなし・タッチで切り替わらない） ---- */
  var lastVisualSp = null;

  function destroyVisual(block) {
    if (!block) return;
    var ctrl = block._facettGsVisual;
    if (ctrl) {
      ctrl.dead = true;
      if (ctrl.timer) {
        window.clearInterval(ctrl.timer);
      }
      if (ctrl.el) {
        ctrl.el.classList.remove('facett-autofade');
        ctrl.el.style.removeProperty('--facett-autofade-speed');
        ctrl.el.querySelectorAll('.swiper-slide').forEach(function (slide) {
          slide.classList.remove('is-autofade-active');
        });
      }
      if (typeof ctrl.destroy === 'function' && !ctrl.timer) {
        try {
          ctrl.destroy(true, true);
        } catch (e) {
          /* ignore */
        }
      }
    }
    block._facettGsVisual = null;
  }

  function initVisual(block) {
    if (!block) return;
    var el = block.querySelector('[data-facett-gift-scenes-visual]');
    if (!el) return;

    if (!isSp()) {
      destroyVisual(block);
      return;
    }

    /* 稼働中なら触らない（iOS resize 連打対策） */
    if (block._facettGsVisual && block._facettGsVisual.timer && !block._facettGsVisual.dead) {
      return;
    }

    destroyVisual(block);

    var slides = Array.prototype.slice.call(el.querySelectorAll('.swiper-slide'));
    if (slides.length <= 1) return;

    var section = block.closest('[data-facett-gift-scenes]');
    var speed = 800;
    var delay = 5000;
    if (section) {
      speed = parseInt(section.getAttribute('data-visual-speed'), 10) || 800;
      delay = parseInt(section.getAttribute('data-visual-delay'), 10) || 5000;
    }

    el.classList.add('facett-autofade');
    el.style.setProperty('--facett-autofade-speed', speed + 'ms');
    el.style.touchAction = 'pan-y';

    var index = 0;
    slides.forEach(function (slide, i) {
      slide.classList.toggle('is-autofade-active', i === 0);
    });

    var ctrl = { el: el, timer: null, dead: false };
    ctrl.timer = window.setInterval(function () {
      if (ctrl.dead) return;
      if (document.hidden) return;
      slides[index].classList.remove('is-autofade-active');
      index = (index + 1) % slides.length;
      slides[index].classList.add('is-autofade-active');
    }, delay);

    block._facettGsVisual = ctrl;
  }

  /* ---- 商品レール ---- */
  function destroyProducts(block) {
    if (!block) return;
    if (block._facettGsSwiper && typeof block._facettGsSwiper.destroy === 'function') {
      try {
        block._facettGsSwiper.destroy(true, true);
      } catch (e) {
        /* ignore */
      }
    }
    block._facettGsSwiper = null;
    block.dataset.facettGsReady = '';
  }

  function clearRailOffset(block) {
    if (!block) return;
    block.style.removeProperty('--facett-gs-rail-offset');
    block.style.removeProperty('--facett-gs-rail-offset-end');
  }

  function applyRailOffset(block, section, el) {
    if (!block || !el) return;
    var offsetBefore = getContentOffset(section, el);
    var offsetAfter = Math.min(offsetBefore, Math.max(getInsetPx(section), 24));
    block.style.setProperty('--facett-gs-rail-offset', offsetBefore + 'px');
    block.style.setProperty('--facett-gs-rail-offset-end', offsetAfter + 'px');
    return { offsetBefore: offsetBefore, offsetAfter: offsetAfter };
  }

  function setStatic(block, on, section, el) {
    block.classList.toggle('facett-gift-scenes__block--static', !!on);
    if (on) {
      applyRailOffset(block, section || block.closest('[data-facett-gift-scenes]') || block, el);
    } else {
      clearRailOffset(block);
    }
  }

  function initProducts(block) {
    if (!block) return;

    var section = block.closest('[data-facett-gift-scenes]') || block;
    var el = block.querySelector('[data-facett-gift-scenes-swiper]');
    if (!el) return;

    var slides = el.querySelectorAll('.swiper-slide');
    var count = slides.length;
    var cardW = getCardW(section);
    var gap = getGap(section);

    destroyProducts(block);
    setStatic(block, false, section, el);

    var offsetBefore = getContentOffset(section, el);
    var offsetAfter = Math.min(offsetBefore, Math.max(getInsetPx(section), 24));

    if (count <= 1) {
      block.classList.add('facett-gift-scenes__block--single');
      setStatic(block, true, section, el);
      block.dataset.facettGsReady = '1';
      return;
    }

    block.classList.remove('facett-gift-scenes__block--single');

    if (!needsSwipe(el, count, offsetBefore, offsetAfter, cardW, gap)) {
      setStatic(block, true, section, el);
      block.dataset.facettGsReady = '1';
      return;
    }

    if (!window.Swiper) return;

    offsetBefore = getContentOffset(section, el);
    offsetAfter = Math.min(offsetBefore, Math.max(getInsetPx(section), 24));

    block._facettGsSwiper = new window.Swiper(el, {
      loop: false,
      speed: 450,
      slidesPerView: 'auto',
      spaceBetween: gap,
      slidesOffsetBefore: offsetBefore,
      slidesOffsetAfter: offsetAfter,
      watchOverflow: true,
      centerInsufficientSlides: false,
      grabCursor: true,
      a11y: { enabled: true },
    });

    if (block._facettGsSwiper.isLocked) {
      destroyProducts(block);
      setStatic(block, true, section, el);
    }

    block.dataset.facettGsReady = '1';
  }

  function destroyScene(block) {
    destroyVisual(block);
    destroyProducts(block);
  }

  function initScene(block) {
    initVisual(block);
    initProducts(block);
  }

  function anyNeedsSwipe(blocks) {
    return Array.prototype.some.call(blocks, function (block) {
      var section = block.closest('[data-facett-gift-scenes]') || block;
      var el = block.querySelector('[data-facett-gift-scenes-swiper]');
      if (!el) return false;
      var count = el.querySelectorAll('.swiper-slide').length;
      if (count <= 1) return false;
      var before = getContentOffset(section, el);
      var after = Math.min(before, Math.max(getInsetPx(section), 24));
      return needsSwipe(el, count, before, after, getCardW(section), getGap(section));
    });
  }

  function syncAll() {
    document.querySelectorAll('[data-facett-gift-scene]').forEach(function (block) {
      initScene(block);
    });
  }

  function boot(force) {
    var blocks = document.querySelectorAll('[data-facett-gift-scene]');
    if (!blocks.length) return;

    var sp = isSp();
    /* SP画像フェードは境界跨ぎ／強制時のみ。商品レールは幅変化で再計算が必要なので別途 */
    var visualNeedsBoot = force || lastVisualSp === null || lastVisualSp !== sp;
    lastVisualSp = sp;

    function run() {
      document.querySelectorAll('[data-facett-gift-scene]').forEach(function (block) {
        if (visualNeedsBoot) {
          initVisual(block);
        }
        initProducts(block);
      });
    }

    if (anyNeedsSwipe(blocks)) {
      Promise.all([loadStylesheet(CSS_HREF), loadScript(JS_SRC)])
        .then(function () {
          window.requestAnimationFrame(run);
        })
        .catch(run);
      return;
    }

    run();
  }

  var resizeTimer = null;
  var lastWidth = window.innerWidth || 0;
  function onResize() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      var w = window.innerWidth || 0;
      /* iOS アドレスバーによる高さ変化だけの resize は無視（幅が同じなら） */
      var widthChanged = Math.abs(w - lastWidth) > 2;
      var spChanged = lastVisualSp !== null && lastVisualSp !== isSp();
      lastWidth = w;
      if (!widthChanged && !spChanged) return;
      boot(spChanged);
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(true);
    });
  } else {
    boot(true);
  }

  window.addEventListener('resize', onResize);

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('[data-facett-gift-scenes]')) {
      lastVisualSp = null;
      boot(true);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target) return;
    event.target.querySelectorAll('[data-facett-gift-scene]').forEach(function (block) {
      destroyScene(block);
    });
  });
})();
